module.exports = __webpack_public_path__ + "media/images/ui__themeToggleLight--dark-498c1401cf4aacb31cbf8c399b75f16e.png";